<template>
  <div class="container">
    <!-- Table desing begin -->
    <div class="d-none d-sm-block">
      <table id="cart" class="table table-hover table-sm">
        <thead>
          <tr>
            <th style="width:50%">Produto</th>
            <th style="width:16%">Precio</th>
            <th style="width:10%">Cant. deseada</th>
            <th style="width:10%">Cant. ofrecida</th>
            <th style="width:16%" class="text-center">Subtotal</th>
          </tr>
        </thead>
        <desktop-item v-for="product in products" :product="product" :key="product.id" :status="status" />
      </table>
    </div>
    <!-- Table desing end -->

    <!-- Responsive desing begin -->
    <div class="d-block d-sm-none">
      <div class="list-group">
        <mobile-item v-for="product in products" :product="product" :key="product.id" :status="status" />
      </div>
    </div>
    <!-- Responsive desing end -->

    <div class="row mt-4 no-gutters">
      <div class="col-6 col-sm-3 align-self-left d-flex align-items-center justify-content-start">
        <button class="btn btn-warning" @click="$router.push('/orders')">
          <span class="text-nowrap">
            <i class="fa fa-angle-left"></i> Volver
          </span>
        </button>
      </div>
      <div class="col-12 col-sm-6 order-first order-sm-0 align-self-center border rounded mb-2 p-1">
        <p>
          Subtotal:
          <span class="float-right">
            {{ subtotalAmount | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
          </span>
        </p>
        <p>
          Servicio ({{percentFee}}%):
          <span class="float-right">
            {{ totalFee | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
          </span>
        </p>
        <p class="font-weight-bold mb-0">
          Total:
          <span class="float-right">
            {{ totalAmount | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
          </span>
        </p>
      </div>
      <div class="col-6 col-sm-3 d-flex align-items-center justify-content-end">
        <button v-if="status === 'R'" class="btn btn-success" @click="$router.push({name: 'Pay', params: { id }})">
          <span class="text-nowrap">
            Pagar
            <i class="fas fa-money-bill-wave"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const DesktopItem = () => import("./DesktopItem.vue");
const MobileItem = () => import("./MobileItem.vue");
import { getOrderApi } from "@/api/modules";
export default {
  props: ["id"],
  components: {
    DesktopItem,
    MobileItem
  },
  data() {
    return {
      status: '',
      totalAmount: 0,
      totalFee: 0,
      subtotalAmount: 0,
      products: []
    };
  },
  computed: {
    percentFee() {
      return Math.round(this.totalFee * 100.00 / this.subtotalAmount);
    }
  },
  created() {
    this.getOrder();
  },
  methods: {
    ...mapActions(["addMessage"]),
    async getOrder() {
      let serviceResponse = await getOrderApi(this.id);
      if (serviceResponse.status) {
        this.status = serviceResponse.data.status;
        this.totalFee = serviceResponse.data.totalFee;
        this.subtotalAmount = serviceResponse.data.subtotalAmount;
        this.totalAmount = serviceResponse.data.totalAmount;
        this.products = serviceResponse.data.products;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  /deep/ h4 {
    font-size: 1.25rem;
  }
}
</style>
